export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration.vue?vue&type=template&id=6244ae73"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/registration.vue?vue&type=template&id=6244ae73
// module id = MtZU
// module chunks = 0